import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "@/data/content";

export default function Projects() {
  return (
    <section id="projects" data-testid="projects-section" className="section">
      <div className="container-x">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#0A3161]/15 bg-[#0A3161]/5 px-3 py-1 text-[12px] font-semibold text-[#0A3161]">
            Student Projects
          </div>
          <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
            Ship real, portfolio-worthy <span className="text-[#B31942]">production apps</span>.
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Every learner builds and deploys these 9 projects — reviewed by industry mentors.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROJECTS.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (i % 3) * 0.06 }}
                className="group relative overflow-hidden rounded-2xl bg-white border border-black/5 p-6 hover:-translate-y-1 transition-transform soft-shadow hover:soft-shadow-lg"
                data-testid={`project-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-[#0A3161] to-[#0E3F84] text-white inline-flex items-center justify-center">
                    <Icon className="h-6 w-6" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-[#B31942] transition-colors" />
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-slate-900">{p.title}</h3>
                <p className="mt-1 text-xs uppercase tracking-widest text-slate-500">{p.tag}</p>
                <div className="absolute -right-6 -bottom-6 h-20 w-20 rounded-full bg-[#B31942]/8 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
